import { render, staticRenderFns } from "./PointsChanges.vue?vue&type=template&id=0b5f391c&scoped=true&"
import script from "@/scripts/Points/components/PointsChanges.js?vue&type=script&lang=js&"
export * from "@/scripts/Points/components/PointsChanges.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f391c",
  null
  
)

export default component.exports